(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationSeriesData', ApplicationSeriesData);

    ApplicationSeriesData.$inject = ['$resource', 'DateUtils'];

    function ApplicationSeriesData ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
